import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  FeatureCard,
  Gallery,
  SpacerV,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import Lottie from "react-lottie";
import { Fragment } from "react";
import { Collage, FAQ2 } from "../components/Sections";

export default function Software() {
  useEffect(() => {}, []);
  const dark = true;

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "75vw",
              }}
            >
              <div
                style={{
                  fontSize: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "5.2vw"
                      : "22px"
                    : "2.2vw",

                  color: "white",
                  zIndex: 999,
                }}
              >
                Building Mobile Apps that
                <br />
                <span style={{ color: "yellow" }}>
                  Connect, Engage, and Empower.
                </span>
              </div>

              <div
                style={{
                  borderBottom: "2px solid white",
                  width: "100%",
                  margin: "25px 0px 25px 0px",
                }}
              ></div>
              <div
                style={{
                  fontSize: state.auth.isMobile ? "25px" : "40px",
                  color: "white",
                  zIndex: 999,
                }}
              >
                Transforming complex challenges into seamless, efficient
                software.
              </div>
            </div>
          </div>
        </div>

        <ContentSideBySideInv
          title={<h2>Key Benefits of Our Mobile Apps</h2>}
          subtitle={
            <div>
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Faster and Smoother User Experience
              </div>
              Our mobile developers create lightweight applications that run
              efficiently on any device. We optimize code to eliminate lag and
              improve speed. Our team prioritizes a responsive interface that
              enhances usability and provides effortless navigation.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Higher Customer Engagement and Retention
              </div>
              We integrate personalized features that keep users engaged and
              invested in the app. Our team adds interactive elements that
              encourage repeat usage and build long-term loyalty. A structured
              notification system designed by our experts ensures timely updates
              that increase retention.
              <br />
              <br />
              <div
                style={{ display: "flex", color: "black", fontWeight: "bold" }}
              >
                <CheckCircleIcon
                  style={{
                    fontSize: "3.6vh",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Scalability for Future Growth
              </div>
              Our mobile developers build applications that grow with business
              demands. A well-structured backend supports increasing user
              activity without affecting performance. We design a flexible
              architecture that allows seamless feature expansion without
              interruptions.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/mobileapp.json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        {!state.auth.isMobile ? (
          <SpacerV height={"100px"} background="white" />
        ) : (
          ""
        )}

        <SpacerV height={"6vh"} background="white" />

        <ThreeSideBySide
          hero={"What Mobile App Development Services Do we Offer"}
          background={""}
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Cross-Platform Compatibility"}
                text={`Our experts develop applications that function seamlessly on iOS and Android. We use a unified codebase that streamlines updates and reduces maintenance efforts. Our approach guarantees consistent performance across all devices.`}
                icon={
                  <TravelExploreIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Ongoing Maintenance and Support"}
                text={`Our team provides continuous support to keep applications updated and secure. We monitor performance and implement necessary security patches. Our experts conduct regular optimizations to improve functionality and user satisfaction.`}
                icon={
                  <BlurOnIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"API and Third-Party Integrations"}
                text={`We integrate powerful third-party solutions to extend app capabilities. Our team connects secure payment gateways and data-syncing APIs that improve functionality and improve user experience.`}
                icon={
                  <DvrIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"Custom UI/UX Design"}
                text={`Our design team creates visually appealing and intuitive app interfaces that captivate users. We carefully structure layouts that guide users seamlessly through the app. Our approach strengthens engagement and improves navigation for a frictionless experience.`}
                icon={
                  <TabIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"50vh"}
                title={"Advanced Security Measures"}
                text={`Our experts implement robust encryption protocols and multi-layer authentication to safeguard user data. We conduct frequent security audits and updates to prevent vulnerabilities and maintain compliance with industry standards.`}
                icon={
                  <WindowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />{" "}
              <br />
              <br />
              <FeatureCard
                minHeight={"50vh"}
                title={"SEO-Optimized Store Presence"}
                text={`Our mobile developers optimize app listings with keyword-driven strategies to improve visibility on Google Play and the App Store. We craft compelling descriptions and select high-impact keywords. We also level up metadata to attract more downloads and increase user acquisition.`}
                icon={
                  <DoubleArrowIcon
                    style={{
                      fontSize: state.auth.isMobile ? "25px" : "6vh",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <FAQ2
          invert={!dark}
          q1="What makes a mobile app successful?"
          a1="A successful mobile app provides a smooth experience and meets user needs. It involves fast loading speeds and intuitive navigation. A structured feature set further augments usability and engagement. Apps with personalized recommendations improve user satisfaction. Seamless onboarding increases adoption rates and keeps users engaged."
          q2="How long does it take to develop a mobile app?"
          a2="App development timelines depend on complexity and functionality. A basic mobile app is completed within eight to twelve weeks. Feature-rich applications with integrations need extended development cycles. Apps requiring third-party API integration take additional testing time. Custom animation and high-security features further extend the timeline."
          q3="What are native and cross-platform apps?"
          a3="Native apps are developed for a single platform and provide better performance. Cross-platform apps work on multiple operating systems and reduce development time. Both approaches offer unique benefits based on business needs. Native apps utilize platform-specific features for a seamless experience. Cross-platform apps reduce costs and allow simultaneous updates across devices."
          q4="Can my mobile app be updated after launch?"
          a4="Yes, apps can be updated for performance improvements and new features. Regular maintenance keeps the app secure and improves functionality. Frequent updates help fix bugs and enhance user experience. Timely feature additions keep the app relevant in a competitive market."
          q5="How does UI/UX impact mobile app performance?"
          a5="A well-structured UI improves navigation and increases user satisfaction. An optimized UX makes interactions seamless and encourages higher retention. Apps with a clear visual hierarchy improve usability. A well-designed interface reduces friction and increases conversions."
          q6="How do I increase app downloads?"
          a6="A strong App Store Optimization (ASO) strategy improves visibility and attracts users. User reviews and structured keyword placements also help improve ranking and discoverability. Optimizing app descriptions increases engagement and conversion rates. Eventually, a well-placed promotional strategy improves organic and paid downloads."
        />
        <Stats />
        <SpacerV height={"100px"} background="#111" />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
